import { useReducer } from "react";
const useToggle = (initialStatus = false) => {
  return useReducer((state) => !state, initialStatus);
};
export {
  useToggle
};
//# sourceMappingURL=useToggle.js.map
